import { RootState } from "@/lib/state/store";

export const editorSelector = (state: RootState) => {
  return state.editor;
};
